import { fetchMPPActiveLeagues, fetchMPPLeague } from '../../../entities/league';

export const scope = 'LEAGUE_MPP';

export function fetchLeagueIfNeeded(payload) {
    return (dispatch, getState) => {
        const { league } = getState().app.other.mpp;

        if (!league.info.isFetching)
            dispatch(fetchMPPLeague(payload, scope));
    };
}

export function fetchActiveLeaguesIfNeeded() {
    return (dispatch, getState) => {
        const { activeLeagues } = getState().app.other.mpp;

        if (!activeLeagues.info.isFetching)
            dispatch(fetchMPPActiveLeagues(scope));
    };
}



// WEBPACK FOOTER //
// ./src/actions/app/other/mpp/league.js